<template>
  <div class="user-setteing">
    <div class="usage-info">
      <h2>ご利用状況</h2>
      <ul>
        <li><span>メーリング件数</span>{{ currentContentCount }} / {{ maxContentCount }}</li>
        <li><span>画像容量</span>{{ Math.ceil(currentImageSize * 100 / 1024 / 1024)  / 100 }}MB / {{ maxImageSize }}MB</li>
        <template v-if="isExtTypeNameEcV1">
          <li><span>EngageCros連携<br>ZIPダウンロード</span>今月残り&nbsp;{{ limitedRemainingEcV1ZipCount }}/{{ maxEcV1ZipCount }}</li>
        </template>
        <template v-else-if="isExtTypeNameEcV2">
          <li><span>EngageCros連携<br>ZIPダウンロード</span>今月残り&nbsp;{{ limitedRemainingEcV2ZipCount }}/{{ maxEcV2ZipCount }}</li>
        </template>
        <template v-else-if="isExtTypeNameMpLite">
          <li><span style="font-size: small;">MailPublisher Lite連携<br>ZIPダウンロード</span>今月残り&nbsp;{{ limitedRemainingEcV2ZipCount }}/{{ maxEcV2ZipCount }}</li>
        </template>
        <template v-else-if="isExtTypeNameMpNext">
          <li><span style="font-size: small;">MailPublisher Next連携<br>ZIPダウンロード</span>今月残り&nbsp;{{ limitedRemainingEcV2ZipCount }}/{{ maxEcV2ZipCount }}</li>
        </template>
        <template v-else>
          <li><span>MailPublisher連携<br>ZIPダウンロード</span>今月残り&nbsp;{{ limitedRemainingMpZipCount }}/{{ maxMpZipCount }}</li>
        </template>
        <li><span>WEB公開</span>今月残り&nbsp;{{ limitedRemainingHostingCount }}/{{ maxHostingCount }}</li>
      </ul>
    </div>
    <div class="user-info">
      <h2>ユーザー情報</h2>
      <ul>
        <li><span>ドメイン</span>{{ mpServiceDomain }}</li>
        <li><span>サイトID</span>{{ mpSiteId }}</li>
        <li><span>ログインID</span>{{ mpAdminId }}</li>
      </ul>
    </div>
    <h2>MailPublisher連携情報</h2>
    <div class="user-setting-inner">
      <label>MailPublisher連携ID</label>
      <input
        type="text"
        class="common-input"
        v-model="mpApiId"
      />
      <label>MailPublisher連携パスワード</label>
      <input
        type="password"
        class="common-input"
        v-model="mpApiPassword"
      />
      <div class="button-box">
        <button class="confirm normal-btn" @click="confirm">確認</button>
        <button class="submit normal-btn" @click="submit">保存</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      mpServiceDomain: '',
      mpSiteId: '',
      mpAdminId: '',
      mpApiId: '',
      mpApiPassword: '',
      maxContentCount: 0,
      currentContentCount: 0,
      maxImageSize: 0,
      currentImageSize: 0,
      maxHostingCount: 0,
      currentHostingCount: 0,
      maxMpZipCount: 0,
      maxEcV1ZipCount: 0,
      maxEcV2ZipCount: 0,
      currentMpZipCount: 0,
      currentEcV1ZipCount: 0,
      currentEcV2ZipCount: 0,
      extTypeName: '',
    }
  },
  async created () {
    this.getUserSettings()
  },
  methods: {
    async getUserSettings () {
      const json = await this.$http({
        url: `/user/settings/mp_api_account`,
        type: 'GET',
      })
      if (json && json.status === 200) {
        this.mpServiceDomain = json.data.mpServiceDomain
        this.mpSiteId = json.data.mpSiteId
        this.mpAdminId = json.data.mpAdminId
        this.mpApiId = json.data.mpApiId
        this.mpApiPassword = json.data.mpApiPassword
        this.extTypeName = json.data.extTypeName
      }
      await this.$http({
        url: '/plan/rate_limit',
        type: 'GET',
      }).then((json) => {
        this.maxContentCount = json.data.plan.mail_max_count
        this.currentContentCount = json.data.using.mail_max_count
        this.maxImageSize = json.data.plan.image_max_size
        this.currentImageSize = json.data.using.image_max_size
        this.maxMpZipCount = json.data.plan.mp_and_zip_export_max_count
        this.maxEcV1ZipCount = json.data.plan.ec_v1_and_zip_export_max_count
        this.maxEcV2ZipCount = json.data.plan.ec_v2_and_zip_export_max_count
        this.currentMpZipCount = json.data.using.mp_and_zip_export_max_count
        this.currentEcV1ZipCount = json.data.using.ec_v1_and_zip_export_max_count
        this.currentEcV2ZipCount = json.data.using.ec_v2_and_zip_export_max_count
        this.maxHostingCount = json.data.plan.hosting_max_count
        this.currentHostingCount = json.data.using.hosting_max_count
      })
    },
    async confirm () {
      const formData = new FormData()
      formData.append('mpApiId', this.mpApiId)
      formData.append('mpApiPassword', this.mpApiPassword)
      await this.$http({
        url: `/user/settings/mp_api_account/confirm`,
        type: 'POST',
        params: formData,
      })
    },
    async submit () {
      const formData = new FormData()
      formData.append('mpApiId', this.mpApiId)
      formData.append('mpApiPassword', this.mpApiPassword)
      await this.$http({
        url: `/user/settings/mp_api_account/update`,
        type: 'POST',
        params: formData,
      })
    },
  },
  computed: {
    limitedRemainingHostingCount () {
      const remainingHostingCount = this.maxHostingCount - this.currentHostingCount
      return remainingHostingCount <= 0 ? 0 : remainingHostingCount
    },
    limitedRemainingMpZipCount () {
      const remainingMpZipCount = this.maxMpZipCount - this.currentMpZipCount
      return remainingMpZipCount <= 0 ? 0 : remainingMpZipCount
    },
    limitedRemainingEcV1ZipCount () {
      const remainingEcV1ZipCount = this.maxEcV1ZipCount - this.currentEcV1ZipCount
      return remainingEcV1ZipCount <= 0 ? 0 : remainingEcV1ZipCount
    },
    limitedRemainingEcV2ZipCount () {
      const remainingEcV2ZipCount = this.maxEcV2ZipCount - this.currentEcV2ZipCount
      return remainingEcV2ZipCount <= 0 ? 0 : remainingEcV2ZipCount
    },
    isExtTypeNameEcV1 () {
      return this.extTypeName === 'ec_v1'
    },
    isExtTypeNameEcV2 () {
      return this.extTypeName === 'ec_v2'
    },
    isExtTypeNameMpLite () {
      return this.extTypeName === 'mp_lite'
    },
    isExtTypeNameMpNext () {
      return this.extTypeName === 'mp_next'
    },
  }
}
</script>

<style lang="scss" scoped>
.user-setteing {
  .user-info, .usage-info {
    margin: 0 0 10px 20px;
    font-size: 14px;
    h2 {
      font-size: 24px;
    }
    ul {
      width: 600px;
      margin: 0 auto 60px;
      li {
        margin-bottom: 10px;
        span {
          font-size: 16px;
          display: inline-block;
          text-align: center;
          width: 150px;
          height: 25px;
          line-height: 25px;
          padding: 0 4px;
          margin-right: 20px;
          border-radius: 12px;
          background: #e4e4e4;
        }
      }
    }
  }
  .usage-info {
    ul {
      li {
        &:nth-of-type(3) {
          display: flex;
          align-items: center;
          span {
            height: auto;
            line-height: 1;
            padding: 5px 4px;
          }
        }
      }
    }
  }
  h2{
    padding-left: 20px;
    margin-bottom: 20px;
    font-size: 24px;
  }
  .user-setting-inner {
    width: 600px;
    margin: 0 auto;
    input, label {
      display: block;
    }
    .common-input {
      width: 600px;
      margin-bottom: 30px;
    }
    .button-box {
      display: flex;
      justify-content: center;
      button {
        margin-right: 20px;
        font-size: 14px;
        border: solid 1px #c6c6c6;
        border-radius: 5px;
        &:hover {
          opacity: 0.8;
        }
        &.confirm {
          margin-right: 20px;
          color: #fff;
          border: solid 1px #484848;
          background: #484848;
        }
      }
    }
  }
}
</style>
